import './js/scripts'

// import 'bootstrap/dist/css/bootstrap.min.css'
import './scss/styles.scss'





// WEBPACK FOOTER //
// ./src/main.js